import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { I18nProvider } from "@lingui/react";
import { i18n } from "@lingui/core";
import { buildYupLocale } from "./utils/yup";
import { defaultLocale, dynamicActivate } from "./utils/i18n";
import ThemeProvider from "./theme";
import reportWebVitals from "./reportWebVitals";
import QueryProvider from "./components/QueryProvider";
import AuthProvider from "./contexts/JWTContext";
import ConfigProvider from "./contexts/ConfigContext";
import App from "./App";
import "react-day-picker/dist/style.css";

dynamicActivate(defaultLocale).then(() => buildYupLocale());

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <BrowserRouter>
    <AuthProvider>
      <ConfigProvider>
        <ThemeProvider>
          <QueryProvider>
            <I18nProvider i18n={i18n}>
              <App/>
            </I18nProvider>
          </QueryProvider>
        </ThemeProvider>
      </ConfigProvider>
    </AuthProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
